import React, { useEffect } from 'react'
import { useSearchParam } from 'react-use'
import toNumber from 'lodash/toNumber'

import { useHistory } from '@ztechapps/common.hook'
import { formatNumber } from '@ztechapps/common.utils'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { routesDef } from '../../../config/routes'
import { useGeneralSearchContext } from './Context'

export { Provider as GeneralSearchProvider, useGeneralSearchContext } from './Context'

//format the numbers in search string to wrapped with quote ("")
const formatSearchString = ({ search }: { search: string }) => {
  const isInches = search.toLowerCase().includes('inch'.toLowerCase())
  let parts = search?.split(' ')

  //remove empty spaces on array
  parts = parts.filter((entry) => entry.trim() !== '')
  const result = []
  for (let item of parts) {
    if (item[0] === `"` && item[item?.length - 1] === `"`) {
      item = item?.replaceAll('"', '')
    }
    const itemToInt = toNumber(item)

    if (isNaN(item as unknown as number)) {
      result.push(item)
      continue
    }
    result.push(`${isInches ? formatNumber(itemToInt, '0.000') : itemToInt}`)
  }

  return result.join(' ')
}

type GeneralSearchProps = {
  onBack?: (value: boolean) => void
  showBackButton?: boolean
}

export default function GeneralSearch({ onBack, showBackButton = true }: GeneralSearchProps) {
  const trackEvent = useTrackEvent()
  const history = useHistory()
  const { search, setSearch } = useGeneralSearchContext()

  const searchParam = useSearchParam('search')

  useEffect(() => {
    setSearch(searchParam || '')
  }, [searchParam, setSearch])

  const onSubmit = (e: React.FormEvent) => {
    e?.preventDefault()

    trackEvent('General Search', { search_term: search })

    const newSearchValue = formatSearchString({ search })

    history?.push(routesDef.ProductListPage.altPath({ search: newSearchValue }))
  }

  return (
    <form onSubmit={onSubmit} className="search" data-joyridestep={'general_search'}>
      <div className="input-group w-100">
        <ShowIf condition={showBackButton}>
          <div className="input-group-prepend d-inline-block d-lg-none">
            <button className="btn btn-secondary" type="button" onClick={() => onBack?.(false)}>
              <Icon name="arrow-left" />
            </button>
          </div>
        </ShowIf>
        <input
          name="search-text"
          type="search"
          className="form-control"
          placeholder="Enter cut dimension or product code."
          value={search}
          onChange={(e) => setSearch(e?.target?.value)}
        />
        <div className="input-group-append">
          <button className="btn btn-secondary" type="submit">
            <Icon name="search" /> <span className="ml-1 d-none d-lg-inline-block">Search</span>
          </button>
        </div>
      </div>
    </form>
  )
}
